export enum ClientDataType {
  AnonSession = 'anonSession',
  Bounce = 'emailBounce',
  Click = 'emailClick',
  Complaint = 'emailComplaint',
  CustomEvent = 'customEvent',
  EmbeddedClick = 'embeddedClick',
  EmbeddedImpression = 'embeddedImpression',
  EmbeddedReceived = 'embeddedReceived',
  EmbeddedSession = 'embeddedSession',
  HostedUnsubscribeClick = 'hostedUnsubscribeClick',
  InAppClick = 'inAppClick',
  InAppClose = 'inAppClose',
  InAppDelete = 'inAppDelete',
  InAppDelivery = 'inAppDelivery',
  InAppOpen = 'inAppOpen',
  InAppRecall = 'inAppRecall',
  InAppSend = 'inAppSend',
  InAppSendSkip = 'inAppSendSkip',
  InboxMessageImpression = 'inboxMessageImpression',
  InboxSession = 'inboxSession',
  JourneyExit = 'journeyExit',
  Open = 'emailOpen',
  Purchase = 'purchase',
  PushBounce = 'pushBounce',
  PushOpen = 'pushOpen',
  PushSend = 'pushSend',
  PushSendSkip = 'pushSendSkip',
  PushUninstall = 'pushUninstall',
  SMSBounce = 'smsBounce',
  SMSClick = 'smsClick',
  SMSReceived = 'smsReceived',
  SMSSend = 'smsSend',
  SMSSendSkip = 'smsSendSkip',
  SMSUsageInfo = 'smsUsageInfo',
  Send = 'emailSend',
  SendSkip = 'emailSendSkip',
  Subscribe = 'emailSubscribe',
  UnSubscribe = 'emailUnSubscribe',
  User = 'user',
  WebPushClick = 'webPushClick',
  WebPushSend = 'webPushSend',
  WebPushSendSkip = 'webPushSendSkip',
  WhatsAppBounce = 'whatsAppBounce',
  WhatsAppClick = 'whatsAppClick',
  WhatsAppConversationOpened = 'whatsAppConversationOpened',
  WhatsAppDelivery = 'whatsAppDelivery',
  WhatsAppReceived = 'whatsAppReceived',
  WhatsAppSeen = 'whatsAppSeen',
  WhatsAppSend = 'whatsAppSend',
  WhatsAppSendSkip = 'whatsAppSendSkip',
  WhatsAppUsageInfo = 'whatsAppUsageInfo',
}
